import react from "react";
import { useEffect, useState, useRef } from "react";
import { formLabelClasses, Modal, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Paper, Grid, Divider } from "@mui/material";
import TokenButton from "./token.button";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
interface TokenSelectProps {
   onTotalChanged: (x: number, y: number) => void;
}

function TokenSelect(props: TokenSelectProps) {
   const { classes } = useStyles();
   const theme = useTheme();

   const [token_a_active, set_token_a_active] = useState(false);
   const [token_b_active, set_token_b_active] = useState(false);
   const [token_c_active, set_token_c_active] = useState(false);
   const [disableNonManual, setDisableNonManual] = useState(false);
   const [modalOpen, setModalOpen] = useState(false);

   function manualTokenOnFocus() {
      if (token_a_active || token_b_active || token_c_active)
         props.onTotalChanged(0, 0);
      set_token_a_active(false);
      set_token_b_active(false);
      set_token_c_active(false);
      setDisableNonManual(true);
   }

   function onDisableNonManual() {
      setDisableNonManual(true);
   }

   function onEnableNonManual() {
      setDisableNonManual(false);
   }

   function A() {
      if (!disableNonManual) {
         //set a active
         set_token_a_active(!token_a_active);
         updateTotalCost(1, !token_a_active);
         //props.onTotalChanged(token_a_active ? 0 : 5);

         //set b and c to false
         set_token_b_active(false);
         set_token_c_active(false);
      }
   }

   function B() {
      if (!disableNonManual) {
         //set b active
         set_token_b_active(!token_b_active);
         updateTotalCost(3, !token_b_active);
         //props.onTotalChanged(token_b_active ? 0 : 15);

         //set a and c to false
         set_token_a_active(false);
         set_token_c_active(false);
      }
   }

   function C() {
      if (!disableNonManual) {
         //set c active
         set_token_c_active(!token_c_active);
         updateTotalCost(5, !token_c_active);
         //props.onTotalChanged(token_c_active ? 0 : 25);

         //set a and b to false
         set_token_a_active(false);
         set_token_b_active(false);
      }
   }

   function updateTotalCost(numberOfTokens: number, selected: boolean) {
      var totalCost = 0;
      var discountPercent = 0;
      if (!selected) {
         props.onTotalChanged(0, 0);
      } else {
         if (numberOfTokens <= 1.0) {
            totalCost = 5 * numberOfTokens;
         } else if (numberOfTokens <= 3.0 && numberOfTokens > 1.0) {
            totalCost = 5 * numberOfTokens;
            discountPercent = 5;
         } else if (numberOfTokens <= 5.0 && numberOfTokens > 3.0) {
            totalCost = 5 * numberOfTokens;
            discountPercent = 10;
         } else if (numberOfTokens > 5.0) {
            totalCost = 5 * numberOfTokens;
            discountPercent = 15;
         }
         props.onTotalChanged(totalCost, discountPercent);
      }
   }

   //pass listeners down from toursemainde
   return (
      <>
         {/* select component container */}
         <section className={classes.SelectComponentContainer}>
            {/* select header */}
            <div className={classes.headerSection}>
               <h4 className={classes.PurchaseTokensHeader}>
                  Purchase Tour Tokens*
               </h4>
               <InfoOutlined
                  style={{
                     color: theme.palette.primary.main,
                     cursor: "pointer",
                     position: "relative",
                     bottom: "2px",
                  }}
                  onClick={() => {
                     setModalOpen(!modalOpen);
                  }}
               />
               <div
                  className={classes.modalContainer}
                  style={{ visibility: modalOpen ? "visible" : "hidden" }}
               >
                  <Paper elevation={3} className={classes.paper}>
                     <Grid container direction={"column"} display="flex">
                        <Grid
                           item
                           display={"flex"}
                           sx={{ alignSelf: "flex-end" }}
                        >
                           <CloseIcon
                              fontSize="small"
                              onClick={() => {
                                 setModalOpen(false);
                              }}
                              style={{
                                 color: theme.palette.common.medGray,
                                 cursor: "pointer",
                              }}
                           />
                        </Grid>
                        <Grid
                           item
                           display={"flex"}
                           sx={{ paddingLeft: "10px", marginBottom: "15px" }}
                        >
                           <div
                              style={{
                                 fontFamily: theme.fonts.secondary.bold,
                                 fontWeight: "bold",
                                 fontSize: "22px",
                              }}
                           >
                              Purchase Tokens
                           </div>
                        </Grid>
                        <Grid
                           item
                           sx={{
                              marginLeft: "10px",
                              marginRight: "10px",
                              marginBottom: "15px",
                           }}
                        >
                           <Divider
                              style={{
                                 borderBottomWidth: "2px",
                                 borderBottomColor: "#A2A2A2",
                                 opacity: 1,
                              }}
                           />
                        </Grid>
                        <Grid item>
                           <div
                              style={{
                                 lineHeight: "1.5",
                                 color: theme.palette.common.medGray,
                                 fontSize: "16px",
                                 marginLeft: "10px",
                              }}
                           >
                              To ensure the safety of property owners and
                              provide verification data through identification
                              checks, tour tokens are required. Buyer agents or
                              agent-led showings tour at no cost.
                           </div>
                        </Grid>
                     </Grid>
                  </Paper>
               </div>
            </div>

            {/* Token Row Section */}
            <section className={classes.TokenRow}>
               <TokenButton
                  onClick={A}
                  active={token_a_active}
                  id="token-1"
                  tokenAmount={1}
               />
               <TokenButton
                  onClick={B}
                  active={token_b_active}
                  id="token-3"
                  tokenAmount={3}
               />
               <TokenButton
                  onClick={C}
                  active={token_c_active}
                  id="token-5"
                  tokenAmount={5}
               />
               <TokenButton
                  onKey={(e) => {
                     let el = e.target as HTMLInputElement;
                     if (el != null) {
                        el.value = el.value.replace(/[^0-9]/g, "");
                        let n = Number.parseFloat(el.value);
                        updateTotalCost(n, disableNonManual);
                        //let cost = n * 5;
                        //if (Number.isNaN(cost)) cost = 0.0;
                        //props.onTotalChanged(cost);
                     }
                  }}
                  disableOtherTokens={onDisableNonManual}
                  enableOtherTokens={onEnableNonManual}
                  onFocus={manualTokenOnFocus}
                  id="manual-token-add"
                  tokenAmount={0}
                  manualEntry={true}
               />
            </section>

            {/* small text section */}

            <section>
               <p className={classes.subText1}>* 1 Token = 1 Tour</p>
               <p className={classes.subText2}>
                  5 Tokens = 1 Month Listing Activation
               </p>
               <p className={classes.subText3}>
                  Tokens are not required for buyer agents touring or agent-led
                  showings with their buyers.
               </p>
            </section>
         </section>
      </>
   );
}

const useStyles = makeStyles({ name: "TokensSelect" })((theme) => ({
   SelectComponentContainer: {
      paddingLeft: "20px",
      width: "100%",
      marginBottom: "15px",
   },
   headerSection: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
   },
   PurchaseTokensHeader: {
      fontFamily: theme.fonts.secondary.med,
      fontSize: "18px",
      marginLeft: "5px",
      marginTop: "0px",
      marginBottom: "10px",
   },
   TokenRow: {
      display: "flex",
      alignItems: "center",
      //justifyContent : 'space-evenly',
      paddingLeft: "5px",
      marginBottom: "20px",
      maxWidth: "450px",
   },
   subText1: {
      fontFamily: theme.fonts.secondary.light,
      fontSize: "12px",
      margin: "0",
   },
   subText2: {
      fontFamily: theme.fonts.secondary.light,
      fontSize: "12px",
      margin: "0",
      marginLeft: "0px",
      paddingLeft: "8px",
   },
   subText3: {
      fontFamily: theme.fonts.secondary.light,
      fontSize: "12px",
      paddingLeft: "8px",
   },
   paper: {
      height: "200px",
      borderRadius: "25px",
      padding: "10px",
      width: "350px",
      display: "flex",
   },
   modalContainer: {
      position: "absolute",
      zIndex: 10,
   },
}));

export default TokenSelect;
